import React, { FC, useEffect } from 'react';

import { IS_INSTALL_PROMPT_SUPPORTED } from './util/windowEnvironment';
import { setupBeforeInstallPrompt } from './util/installPrompt';
import { RouterProvider } from 'react-router';
import { AppRouter } from './routes';
import { Helmet } from 'react-helmet';

import './util/i18n';
import './assets/styles/styles.scss';
import { DEFAULT_APP_TITLE } from './config';

const App: FC = () => {
  useEffect(() => {
    if (IS_INSTALL_PROMPT_SUPPORTED) {
      setupBeforeInstallPrompt();
    }
  }, []);

  // Prevent drop on elements that do not accept it
  useEffect(() => {
    const body = document.body;
    const handleDrag = (e: DragEvent) => {
      e.preventDefault();
      if (!e.dataTransfer) return;
      if (!(e.target as HTMLElement).dataset.dropzone) {
        e.dataTransfer.dropEffect = 'none';
      } else {
        e.dataTransfer.dropEffect = 'copy';
      }
    };
    const handleDrop = (e: DragEvent) => {
      e.preventDefault();
    };
    body.addEventListener('drop', handleDrop);
    body.addEventListener('dragover', handleDrag);
    body.addEventListener('dragenter', handleDrag);

    return () => {
      body.removeEventListener('drop', handleDrop);
      body.removeEventListener('dragover', handleDrag);
      body.removeEventListener('dragenter', handleDrag);
    };
  }, []);

  return (
    <>
      <Helmet
        defaultTitle={DEFAULT_APP_TITLE}
        titleTemplate={`${DEFAULT_APP_TITLE} - %s`}
      />
      <RouterProvider router={AppRouter} />
    </>
  );
};

export default App;
